import { Map } from 'immutable'

export const isWorkspaceAnimating = (state, module, id) => {
    const isSomeBlockAnimating = !!state
        .getIn(['ui', 'workspace', module, id, 'blocks'], Map())
        .find((block) => block.get('isAnimating'))

    return isSomeBlockAnimating || false
}
